
<img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/>

<ion-content>

  <ion-menu-toggle class="SCWEB-menu-icon">
    <ion-button color="white">
      <img src="assets/img/shortcut-icon.png" class="SCWEB-menu-img" />
    </ion-button>
  </ion-menu-toggle>

  <div class="page-wrapper">

    <div class="name-img-wrapper">
      <img src="assets/img/shortcut-icon.png" class="img" />
      <div class="name">Product Sales</div>
    </div>

    <div class="tabs">
      <span class="tab" [ngClass]="selectedTab === 'For Sale' ? 'selected-tab' : ''" (click)="selectTab('For Sale')">For Sale</span>
      <span class="tab" [ngClass]="selectedTab === 'Orders' ? 'selected-tab' : ''" (click)="selectTab('Orders')">Orders</span>
      <span class="tab" [ngClass]="selectedTab === 'Settings' ? 'selected-tab' : ''" (click)="selectTab('Settings')">Settings</span>
    </div>

    <div *ngIf="selectedTab === 'For Sale'" class="tab-content for-sale">
      <div class="section-header" *ngIf="productsReady">Products for Sale ({{activeProducts.length}})</div>
      <ion-item class="input-item bottom-border" lines="none" *ngIf="activeProducts && !activeProducts.length">
        <ion-label>
          Nothing here.
        </ion-label>
      </ion-item>
      <ion-item class="input-item bottom-border clickable-label" lines="none" *ngFor="let p of activeProducts" (click)="deactivateProduct(p.id)">
        <div class="product-dot active-dot"></div>
        <ion-label>
          {{p.name}} ({{formatCost(p.listPrice, p.currency)}})
          <p>
            SKU: {{p.sku}} | SCID: {{p.id}} | Sales: {{p.numSales}}
          </p>
        </ion-label>
      </ion-item>

      <br>
      <div class="section-header" *ngIf="productsReady && inactiveProducts.length">Inactive Products ({{inactiveProducts.length}})</div>
      <ion-item class="input-item bottom-border clickable-label" lines="none" *ngFor="let p of inactiveProducts" (click)="activateProduct(p.id)">
        <div class="product-dot inactive-dot"></div>
        <ion-label>
          {{p.name}} ({{formatCost(p.listPrice, p.currency)}})
          <p>
            SKU: {{p.sku}} | SCID: {{p.id}} | Sales: {{p.numSales}}
          </p>
        </ion-label>
      </ion-item>

      <br>

      <span (click)="addProduct()" class="add-option" *ngIf="productsReady && !addingProduct">
        <ion-icon name="add-outline"></ion-icon>
        Add new product
      </span>

      <div *ngIf="loaded" [hidden]="!addingProduct" class="adding-payment">
        <div class="section-header">Add new product</div>

        <ion-grid>
          <ion-row>
            <ion-col size="6">
              <ion-item class="booking-input col-input" lines="none">
                <ion-input placeholder="Product name" [(ngModel)]="productFields.name" type="text"></ion-input>
              </ion-item>
            </ion-col>
            <ion-col size="6">
              <ion-item class="booking-input col-input" lines="none">
                <ion-input placeholder="SKU" [(ngModel)]="productFields.sku" type="text"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6">
              <ion-item class="booking-input col-input" lines="none">
                <ion-input placeholder="Description" [(ngModel)]="productFields.description" type="text"></ion-input>
              </ion-item>
            </ion-col>
            <ion-col size="6">
              <ion-item class="booking-input col-input" lines="none">
                <ion-input placeholder="List price (in {{userService.business.currency}})" [(ngModel)]="productFields.listPriceString" type="text"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12">
              <ion-item class="booking-input col-input" lines="none">
                <ion-input placeholder="Notes (not visible to customers)" [(ngModel)]="productFields.otherDetails" type="text"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-item class="img-uploader" lines="none">
              <div *ngIf="!productFields.photoURL">
                <ion-label (click)="addProductImage()">
                  <ion-button>Add product image</ion-button>
                  <br>
                  <span>Upload a .png or .jpg image file.</span>
                  <span>Suggested dimensions: 700px wide × 335px tall.</span>
                </ion-label>
              </div>

              <div *ngIf="productFields.photoURL">
                <ion-img [src]="productFields.photoURL" class="actual-img" (click)="addProductImage()"></ion-img>
              </div>
            </ion-item>
          </ion-row>
        </ion-grid>

        <div class="submit-button">
          <ion-button color="marine" (click)="submitNewProduct()" class="save-button SC-floating-button SC-floating-button-wide SC-floating-button-less-tall">
            Add to catalog
          </ion-button>
          <ion-button class="cancel-button" fill="clear" (click)="closeNewProduct()">
            Cancel
          </ion-button>
        </div>
      </div>

      <br>
    </div>

    <div *ngIf="selectedTab === 'Orders'" class="tab-content orders">
      <div class="section-header">In-App Orders</div>
      <ion-item class="input-item bottom-border" lines="none">
        <ion-label> Coming soon. </ion-label>
      </ion-item>
    </div>

    <div *ngIf="selectedTab === 'Settings'" class="tab-content settings">
      <div class="section-header">Commission structure</div>

      <ion-item class="input-item bottom-border" lines="none">
        <ion-label> Shortcut transaction fee: <b>{{formatPercentage(0.05)}}</b></ion-label>
      </ion-item>

      <ion-item class="commission-tiers" lines="none">
        <ion-label>
          Pro product commission tiers
          <div class="commission-options">
            <p class="commission-tier" *ngFor="let c of commissionOptions">
              {{c.name}}: {{formatPercentage(c.commission)}}
            </p>
            <p *ngIf="commissionOptions && commissionOptions.length == 0" class="commission-missing">Missing: Please add at least one commission tier.</p>
            <p><span (click)="promptAddCommissionOption()" class="add-option">
              <ion-icon name="add-outline"></ion-icon>
              Add option
            </span></p>
          </div>
        </ion-label>
      </ion-item>

      <ion-item class="input-item" lines="none">
        <ion-label>
          <p>
            Remember to assign commission tiers to Pros via <span class="link-button" (click)="openProSettings()">Pro Settings</span>.
          </p>
        </ion-label>
      </ion-item>
    </div>
  </div>

</ion-content>

<ion-footer slot="fixed" class="SC-support-footer">
  <span class="support-button" (click)="openPage('https://getshortcut.co/faq')">FAQ</span>
  <span class="support-button" (click)="adminChat()">Live chat</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/privacy')">Privacy policy</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/terms')">Terms of service</span>
</ion-footer>